exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (min-width: 768px ) {\n.room-type-container[data-v-46c1671e]{\n        /*height: 200px !important;*/\n        /*overflow:hidden;*/\n}\n}\n\n", ""]);

// exports
